import React from "react";
import AllSubjectTopics from "../../../topics/AllSubjectTopics";

function ErrorLessBioTopics() {
  return (
    <>

      <AllSubjectTopics  subject="biology" type="errorlessbook" />

    </>
  );
}

export default ErrorLessBioTopics;